import { jwtDecode } from "jwt-decode";

export const getAuthToken = () => {
  try {
    return localStorage.getItem("auth_token") || null;
  } catch {
    return null;
  }
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem("user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getStoredUserId = () => {
  const user = getStoredUser();
  if (!user) return null;
  // Prefer `user_id` as per latest API, fallback to common aliases
  return user.user_id || user.uuid || user.id || null;
};


export const isTokenExpired = (token) => {
  if (!token) {
    localStorage.clear();
    return true;
  }
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    if (decodedToken.exp < currentTime) {
      localStorage.clear();
      return true;
    } else {
      return false;
    }
  } catch {
    localStorage.clear();
    return true;
  }
};


export const isAuthTokenValid = () => {
  const token = getAuthToken();
  return !isTokenExpired(token);
};

export const getUserPermissions = (user) => {
  if (!user) return {};
  return user.role?.permissions || {};
};


